import React from 'react';
import './PrivacyPolicy.css';

export default function TermsOfServiceFR() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy__hero">
        <div className="container">
          <h1>Conditions d'utilisation</h1>
          <p className="privacy-policy__date">Date d'entrée en vigueur : 1er décembre 2024</p>
        </div>
      </div>

      <div className="container privacy-policy__content">
        <div className="privacy-policy__contact-box">
          <p><strong>Vision Sécurité Inc.</strong></p>
          <p>Adresse : 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
          <p>Courriel : <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></p>
          <p>Téléphone : <a href="tel:+15142797209">(514) 279-7209</a></p>
        </div>

        <p style={{fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '20px'}}>
          VEUILLEZ LIRE ATTENTIVEMENT CES CONDITIONS D'UTILISATION AVANT D'UTILISER CE SITE WEB
        </p>

        <section>
          <h2>1. Introduction et acceptation</h2>
          <p>
            Les présentes Conditions d'utilisation (« Conditions ») constituent un accord juridiquement contraignant entre 
            vous (personnellement ou au nom d'une entité) et Vision Sécurité Inc. (« Vision Sécurité », « nous », « notre » 
            ou « nos ») régissant votre accès et votre utilisation du site Web www.vision-security.ca et de tous les 
            sous-domaines connexes, applications mobiles ou autres plateformes numériques exploitées par Vision Sécurité 
            (collectivement, le « Site Web »).
          </p>
          <p>
            En accédant au Site Web ou en l'utilisant, vous reconnaissez avoir lu, compris et accepté d'être lié par les 
            présentes Conditions et notre Politique de confidentialité. Si vous n'acceptez pas ces Conditions, vous devez 
            immédiatement cesser d'utiliser le Site Web.
          </p>
          <p>Nous vous recommandons d'imprimer ou de sauvegarder une copie de ces Conditions pour vos dossiers.</p>
        </section>

        <section>
          <h2>2. Qui nous sommes et comment nous contacter</h2>
          <p>
            Vision Sécurité Inc. est une entreprise de services de sécurité professionnels enregistrée et opérant dans la 
            province de Québec, au Canada. Nous fournissons des solutions de sécurité complètes, notamment des agents de 
            sécurité en uniforme, des services de patrouille mobile, du contrôle d'accès, de l'intervention d'incident et 
            du conseil en sécurité spécialisé à travers Montréal, Laval et la grande région de Québec.
          </p>
          <p><strong>Siège social :</strong> 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
          <p><strong>Coordonnées :</strong></p>
          <ul>
            <li>Demandes générales : <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></li>
            <li>Demandes sur le site Web/Conditions : <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></li>
            <li>Téléphone : <a href="tel:+15142797209">(514) 279-7209</a></li>
          </ul>
          <p>
            Pour les questions relatives à la confidentialité, veuillez contacter notre Responsable de la protection des 
            renseignements personnels tel que spécifié dans notre Politique de confidentialité.
          </p>
        </section>

        <section>
          <h2>3. Politiques et documents additionnels</h2>
          <p>Les présentes Conditions incorporent par renvoi et doivent être lues conjointement avec les politiques additionnelles suivantes :</p>
          <ul>
            <li>
              <strong>Politique de confidentialité :</strong> Explique comment nous recueillons, utilisons, divulguons et 
              protégeons vos renseignements personnels conformément à la Loi 25 du Québec et à la LPRPDE.
            </li>
            <li>
              <strong>Politique sur les témoins :</strong> Explique comment nous utilisons les témoins et les technologies 
              de suivi similaires sur le Site Web.
            </li>
          </ul>
          <p>
            Si vous demandez une soumission de services de sécurité, une proposition ou concluez une entente de service avec 
            Vision Sécurité, les termes et conditions de ce contrat spécifique régiront la prestation des services de sécurité.
          </p>
        </section>

        <section>
          <h2>4. Admissibilité à utiliser le Site Web</h2>
          <p>En utilisant le Site Web, vous déclarez et garantissez que :</p>
          <ul>
            <li>Vous avez au moins dix-huit (18) ans ou l'âge de la majorité dans votre juridiction, selon le plus élevé</li>
            <li>Vous possédez la capacité juridique de conclure un accord contraignant</li>
            <li>Vous n'êtes pas interdit par la loi d'accéder au Site Web ou de l'utiliser</li>
            <li>Tous les renseignements que vous nous fournissez sont exacts, à jour et complets</li>
          </ul>
          <p>
            Si vous accédez au Site Web au nom d'une entreprise ou d'une organisation, vous déclarez avoir l'autorité de lier 
            cette entité aux présentes Conditions.
          </p>
        </section>

        <section>
          <h2>5. Modifications de ces Conditions</h2>
          <p>
            Nous nous réservons le droit de modifier, d'amender ou de mettre à jour ces Conditions à tout moment pour refléter 
            les changements dans nos opérations, les exigences légales ou les pratiques commerciales.
          </p>
          <p>
            Lorsque nous apportons des modifications, nous mettrons à jour la date de « Dernière mise à jour » en haut de cette 
            page. Pour les modifications importantes, nous fournirons un avis supplémentaire.
          </p>
        </section>

        <section>
          <h2>6. Modifications du Site Web</h2>
          <p>
            Nous pouvons mettre à jour, modifier, suspendre ou interrompre le Site Web ou toute partie de celui-ci à tout moment 
            sans préavis.
          </p>
          <p>
            Nous ne garantissons pas que le Site Web sera toujours disponible, ininterrompu, sécurisé ou exempt d'erreurs.
          </p>
        </section>

        <section>
          <h2>7. Comptes d'utilisateur et sécurité</h2>
          <p>
            Certaines zones du Site Web peuvent nécessiter une inscription ou la création d'un compte d'utilisateur. Si vous 
            recevez ou choisissez un nom d'utilisateur, un mot de passe ou toute autre information d'identification, vous devez :
          </p>
          <ul>
            <li>Traiter ces renseignements comme strictement confidentiels</li>
            <li>Ne pas divulguer vos identifiants à un tiers</li>
            <li>Nous aviser immédiatement à <a href="mailto:info@vision-security.ca">info@vision-security.ca</a> si vous 
            savez ou soupçonnez un accès non autorisé</li>
            <li>Être responsable de toutes les activités sous votre compte</li>
          </ul>
        </section>

        <section>
          <h2>8. Droits de propriété intellectuelle</h2>
          <h3>Propriété</h3>
          <p>
            Vision Sécurité et nos concédants de licence possèdent tous les droits de propriété intellectuelle sur le Site Web 
            et son contenu. Le Contenu est protégé par les lois canadiennes et internationales sur le droit d'auteur, les marques 
            de commerce et d'autres lois sur la propriété intellectuelle.
          </p>
          
          <h3>Licence limitée</h3>
          <p>
            Sous réserve de votre conformité aux présentes Conditions, nous vous accordons une licence limitée, non exclusive, 
            non transférable et révocable pour accéder au Site Web et l'utiliser à des fins personnelles et non commerciales uniquement.
          </p>
        </section>

        <section>
          <h2>9. Marques de commerce</h2>
          <p>
            Le nom « Vision Sécurité », notre logo et tous les noms, logos, noms de produits et de services connexes sont des 
            marques de commerce de Vision Sécurité Inc. Vous ne pouvez pas utiliser ces marques sans notre autorisation écrite préalable.
          </p>
        </section>

        <section>
          <h2>10. Conduite interdite et utilisation acceptable</h2>
          <p>
            Vous acceptez d'utiliser le Site Web uniquement à des fins légales et conformément aux présentes Conditions. Vous 
            acceptez de ne pas vous livrer à des activités illégales ou nuisibles, violations de contenu, interférence technique 
            ou utilisation abusive des données.
          </p>
        </section>

        <section>
          <h2>11. Liens et ressources tiers</h2>
          <p>
            Le Site Web peut contenir des liens vers des sites Web tiers. Ces liens sont fournis pour votre commodité uniquement. 
            Nous n'endossons ni n'assumons aucune responsabilité pour le contenu tiers.
          </p>
        </section>

        <section>
          <h2>12. Exclusion de garanties</h2>
          <p style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
            LE SITE WEB ET TOUT LE CONTENU SONT FOURNIS « TELS QUELS » ET « SELON LA DISPONIBILITÉ » SANS GARANTIE D'AUCUNE SORTE.
          </p>
          <p>
            Dans toute la mesure permise par la loi applicable, Vision Sécurité exclut toutes les garanties implicites.
          </p>
        </section>

        <section>
          <h2>13. Limitation de responsabilité</h2>
          <p style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
            DANS TOUTE LA MESURE PERMISE PAR LA LOI, Vision Sécurité ne sera pas responsable des dommages indirects, accessoires, 
            spéciaux, consécutifs ou punitifs.
          </p>
          <p>
            En aucun cas la responsabilité totale de Vision Sécurité ne dépassera cent dollars canadiens (100,00 $ CAD).
          </p>
        </section>

        <section>
          <h2>14. Indemnisation</h2>
          <p>
            Vous acceptez d'indemniser Vision Sécurité de toute réclamation découlant de votre utilisation du Site Web, violation 
            de ces Conditions ou violation de lois ou droits de tiers.
          </p>
        </section>

        <section>
          <h2>15. Loi applicable et résolution des litiges</h2>
          <h3>Loi applicable</h3>
          <p>
            Ces Conditions seront régies conformément aux lois de la province de Québec et aux lois fédérales du Canada qui s'y appliquent.
          </p>
          
          <h3>Juridiction</h3>
          <p>
            Toute action judiciaire sera intentée exclusivement devant les tribunaux situés à Montréal, Québec.
          </p>
          
          <h3>Langue des procédures</h3>
          <p>
            Les parties exigent expressément que ces Conditions soient rédigées en anglais. Les parties conviennent que la présente 
            convention ainsi que tous les documents qui s'y rattachent soient rédigés en anglais.
          </p>
        </section>

        <section>
          <h2>16. Dispositions générales</h2>
          <p>
            Ces Conditions constituent l'accord intégral entre vous et Vision Sécurité concernant le Site Web. Si une disposition 
            est jugée invalide, les dispositions restantes continuent de s'appliquer.
          </p>
        </section>

        <section>
          <h2>17. Coordonnées</h2>
          <p>Pour toute question concernant ces Conditions d'utilisation, veuillez nous contacter :</p>
          <div className="contact-details-box">
            <p><strong>Vision Sécurité Inc.</strong></p>
            <p>Adresse : 3285 Boul. Cavendish, Suite 620, Montréal, Québec H4B 2L9, Canada</p>
            <p>Courriel : <a href="mailto:info@vision-security.ca">info@vision-security.ca</a></p>
            <p>Téléphone : <a href="tel:+15142797209">(514) 279-7209</a></p>
            <p>Légal : <a href="mailto:legal@vision-security.ca">legal@vision-security.ca</a></p>
            <p style={{marginTop: '15px', fontStyle: 'italic'}}>
              Pour les demandes relatives à la confidentialité, veuillez contacter notre Responsable à 
              <a href="mailto:privacy@vision-security.ca"> privacy@vision-security.ca</a>.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
